module.exports = __webpack_public_path__ + "resources/img/btn-drop-down@2x.8c12a27bb46f807267ec8e8110605542.png";